import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { addDaysToDate, formatMoney, getCurrentDateForInput, getInlineLoader, remove255 } from "../Helpers";
import {
	STR_AVAILABLE_HOTELS,
	STR_AVAILABLE_ROOMS,
	STR_BOOK_NOW,
	STR_BOOK_THIS_ROOM,
	STR_CHANGE_PHONE_NUMBER,
	STR_CHECK_IN_DATE,
	STR_CHECK_OUT_DATE,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_ENTER_PHONE_NUMBER_FOR_PAYMENT,
	STR_FINALIZE_PAYMENT_CARD,
	STR_FINALIZE_PAYMENT_MOBILE,
	STR_GO_BACK,
	STR_INVALID_CHECK_IN_DATE,
	STR_INVALID_NUMBER_OF_DAYS,
	STR_INVALID_PAYWITH,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_NUMBER_OF_DAYS,
	STR_OVERALL_COST,
	STR_PAY_WITH_CARD,
	STR_PAY_WITH_MOBILE,
	STR_PAYMENT_SETTINGS,
	STR_PER_DAY,
	STR_PERSONAL_SETTINGS,
	STR_RESERVED,
	STR_ROOM,
	STR_STARTING_FROM_DATE,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_TOTAL_ORDER_PRICE,
	STR_TRANSACTION_FEEs,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdContactPage, MdHotel, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdRoom, MdSupportAgent, MdTranslate, MdWarning } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import OneHotelRoom from '../ones/OneHotelRoom';
import ImagesSlider from "../ones/ImagesSlider";
import { CDN_URL, callApi } from "../Helpers";
import MobileInterface from "../MobileInterface";

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState(null);
	const [images, setImages] = useState([]);

	const [checkInDate, setCheckInDate] = useState(getCurrentDateForInput());
	const [checkOutDate, setCheckOutDate] = useState(getCurrentDateForInput() + 1);
	const [numberOfDays, setNumberOfDays] = useState(1);
	const [payWith, setPayWith] = useState('mobile_money');
	const [payPhone, setPayPhone] = useState(remove255(appContext.currentUserData.phone));
	const [overallCost, setOverallCost] = useState(0);
	const [transactionFees, setTransactionFees] = useState(appContext.systemParams.transactionFees);
	const [totalOrderPrice, setTotalOrderPrice] = useState(0);
	const [realPricePerDay, setRealPricePerDay] = useState(0);
	const [hotelData, setHotelData] = useState(null);

	const [opSuccessful, setOpSuccessful] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getData(),
		]);
		setReady(true);
	}


	async function getData() {
		await callApi('get-hotel-room-data', { id }).then(async (response) => {
			if(response.status === 1) {
				setData(response.data)
				await getHotelData(response.data.hotelId);
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	async function getHotelData(id) {
		await callApi('get-hotel-data', { id }).then((response) => {
			if(response.status === 1) {
				setHotelData(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}


	function getImages() {
		if (data) {
			const _images = [];

			if (data.photo1) {
				_images.push(CDN_URL + data.photo1)
			}

			if (data.photo2) {
				_images.push(CDN_URL + data.photo2)
			}

			if (data.photo3) {
				_images.push(CDN_URL + data.photo3)
			}
			
			if (data.photo4) {
				_images.push(CDN_URL + data.photo4)
			}

			if (data.photo5) {
				_images.push(CDN_URL + data.photo5)
			}

			setImages(_images);
		}
	}

	function calculateTotalOrderPrice() {
		if(Number(numberOfDays) > 0 && data) {
			let _totalOrderPrice = Number(numberOfDays) * Number(realPricePerDay);
			setTotalOrderPrice(_totalOrderPrice);
		} else {
			setTotalOrderPrice(0);
		}
	}

	function calculateOverallCost() {
		const _overallCost = Number(transactionFees) + Number(totalOrderPrice);
		setOverallCost(_overallCost);
	}

	function calculateTransactionFees() {
		/*
		const paymentProcessorFee = Number(appContext.systemParams.selcomPercent) / 100;
		const fees = totalOrderPrice * paymentProcessorFee / (1 - paymentProcessorFee);
    setTransactionFees(Math.floor(fees));
		*/

		setTransactionFees(appContext.systemParams.transactionFees);
	}

	async function placeOrder() {
		if(Number(numberOfDays) > 0) {
			if(checkInDate && checkInDate.trim().length > 0) {
				if(
					(payWith === 'mobile_money' && payPhone && payPhone.trim().length === 10) ||
					(payWith === 'credit_card')
				) {
					setLoading(true);
					await callApi(
						'create-room-order',
						{
							roomId: data.id,
							numberOfDays,
							checkInDate,
							checkOutDate,
							payWith,
							payPhone,
						}
					).then(response => {
						if(response.status === 1) {
							setOpSuccessful(true);
							if (payWith === 'credit_card') {
								MobileInterface.openLink(response.payment_gateway_url);
							}
						} else {
							appContext.tellError(response.msg);
						}
					})
					setLoading(false);
				} else {
					appContext.tellError(STR_INVALID_PAYWITH[appContext.language]);
				}
			} else {
				appContext.tellError(STR_INVALID_CHECK_IN_DATE[appContext.language]);
			}
		} else {
			appContext.tellError(STR_INVALID_NUMBER_OF_DAYS[appContext.language]);
		}
	}

	function getRealPricePerDay() {
		if(data && hotelData) {
			let _price = Number(data.pricePerDay) * (1 + (Number(hotelData.platformFeePercent)/100));

			setRealPricePerDay(_price);
		}
	}

	useEffect(() => {
		getRealPricePerDay();
	}, [ hotelData, data ])

	useEffect(() => {
		getImages();
	}, [ data ])


	useEffect(() => {
		init();
	}, [])

	

	useEffect(() => {
		//calculate transaction fees
		calculateOverallCost();
	}, [ totalOrderPrice, transactionFees ])

	useEffect(() => {
		calculateTotalOrderPrice();
	}, [ numberOfDays, data, realPricePerDay ])

	useEffect(() => {
		if(Number(numberOfDays) > 0 && checkInDate) {
			setCheckOutDate(addDaysToDate(checkInDate, numberOfDays));
		} else {
			setCheckOutDate("")
		}
	}, [ numberOfDays, checkInDate ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (	
			<div className="container">	
				{
					(opSuccessful) ?
					<div className="row">
						<div className="col-md-12 text-center">
							<h6
								style={{
									fontSize: "22px",
									padding: "30px"
								}}
							>
								<MdCheckCircle className="text-secondary mb-5" size={92}/>
								<br/>

								{(payWith === 'mobile_money') ? STR_FINALIZE_PAYMENT_MOBILE[appContext.language] : ""}
								{(payWith === 'credit_card') ? STR_FINALIZE_PAYMENT_CARD[appContext.language] : ""}
							</h6>

							<button
								className="btn btn-rounded btn-padded btn-secondary"
								onClick={appContext.navBack}
							>
								{STR_GO_BACK[appContext.language]}
							</button>
						</div>
					</div>
					:			
					<div className="row">
						<div className="col-md-12">
							<ImagesSlider images={images}/>
						</div>

						<div className="col-md-12">
							<h6
								style={{
									fontSize: "24px"
								}}
								className="mt-4 mb-2 text-primary font-bold"
							>
								<MdHotel size={42}/>
								<br/>
								{data.name}
							</h6>

							

							{
								(data.description || JSON.parse(data.features).length > 0) ?
								<div className="">
									<pre className="mb-4">
										{data.description}
									</pre>

									{
										(JSON.parse(data.features).map((item, i) => {
											return (
												<h6
													style={{
														fontSize: "18px"
													}}
													className="font-semi-bold"
													key={i}
												>
													<MdCheckCircle className="text-secondary" size={24}/>
													{appContext.getRoomAttributeName(item)}
												</h6>
											)
										}))
									}
								</div>
								:""
							}

							<h6
								style={{
									fontSize: "36px"
								}}
								className="mt-4 mb-4 text-dark font-light text-end"
							>
								{formatMoney(realPricePerDay)} TZS
								<span style={{ fontSize: "14px" }} className="d-block font-semi-bold text-primary">{STR_PER_DAY[appContext.language]}</span>
							</h6>

						</div>

						<div className="col-md-12 mt-4 mb-4">
							{
								(data.isAvailable === 'yes' && data.isBooked === 'no') ?
								<div className="card">
									<div className="card-body">
										<h6 className="card-title text-center">{STR_BOOK_THIS_ROOM[appContext.language]}</h6>
										<hr/>

										<div className="row">

											<div className="col-12 mb-5 mt-4">
												<div 
													className="text-center"
													style={{
														maxWidth: "150px",
														margin: "0 auto"
													}}
												>
													
													<label style={{ textTransform: "uppercase" }} className="form-label text-primary font-bold">{STR_NUMBER_OF_DAYS[appContext.language]}</label>
													<input
														className="form-control text-center"
														value={numberOfDays}
														type="number"
														onChange={e => {
															if(!isNaN(Number(e.target.value))) {
																setNumberOfDays(Number(e.target.value));
															} else {
																setNumberOfDays(1);
															}
														}}
														style={{
															fontSize: "32px"
														}}
													/>
													
												</div>
											</div>

											<div className="col-12 mt-3 mb-3">
												<table className="table table-striped">
													<thead>
														<tr>
															<th></th>
															<th className="text-end">TZS</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td style={{ fontSize: "14px" }}>{STR_TOTAL_ORDER_PRICE[appContext.language]}</td>
															<td className="text-end">{formatMoney(totalOrderPrice)}</td>
														</tr>

														<tr className="">
															<td style={{ fontSize: "14px" }}>{STR_TRANSACTION_FEEs[appContext.language]}</td>
															<td className="text-end">{formatMoney(transactionFees)}</td>
														</tr>

														<tr>
															<td style={{ fontSize: "14px" }}>{STR_OVERALL_COST[appContext.language]}</td>
															<td style={{ fontSize: "18px" }} className="text-end font-semi-bold">{formatMoney(overallCost)}</td>
														</tr>
													</tbody>
												</table>
											</div>

											<div className="col-12">
												<label className="form-label">{STR_CHECK_IN_DATE[appContext.language]}</label>
												<input
													className="form-control"
													type="date"
													value={checkInDate}
													onChange={e => setCheckInDate(e.target.value)}
													min={getCurrentDateForInput()} 
												/>
											</div>	

											<div className="col-12">
												<label className="form-label">{STR_CHECK_OUT_DATE[appContext.language]}</label>
												<input
													className="form-control"
													type="date"
													value={checkOutDate}
													onChange={e => setCheckOutDate(e.target.value)}
													readOnly
												/>
											</div>	

											<div className="col-12 mt-5 mb-4">
												<button
													className={(payWith === 'mobile_money') ? "btn btn-block btn-primary" : "btn btn-block btn-outline-primary"}
													style={{
														fontSize: "14px",
														height: "80px",
													}}
													onClick={() => setPayWith('mobile_money')}
												>
													{STR_PAY_WITH_MOBILE[appContext.language]}
												</button>
												
											</div>

											<div className="col-6 mt-5 mb-4 d-none">
												<button
													className={(payWith === 'credit_card') ? "btn btn-block btn-primary" : "btn btn-block btn-outline-primary"}
													style={{
														fontSize: "14px",
														height: "80px",
													}}
													onClick={() => setPayWith('credit_card')}
												>
													{STR_PAY_WITH_CARD[appContext.language]}
												</button>
												
											</div>

											<div className="col-12 mt-4" style={{ display: (payWith === 'mobile_money') ? 'block' : 'none' }}>
												<label className="form-label">{STR_ENTER_PHONE_NUMBER_FOR_PAYMENT[appContext.language]}</label>
												<input
													className="form-control"
													value={payPhone}
													onChange={e => setPayPhone(e.target.value)}
													maxLength={10}
												/>
											</div>	

											<div className="col-12 mt-4 mb-4">
												<button
													className="btn btn-block btn-padded btn-rounded btn-secondary"
													onClick={placeOrder}
												>
													{STR_BOOK_NOW[appContext.language]}
												</button>
											</div>

										</div>

									</div>
								</div>
								:
								<div className="card">
									<div className="card-body text-center">
										<MdWarning size={56} className="text-secondary"/>
										
										<h6
											style={{
												fontSize: "22px"
											}}
											className="font-semi-bold"
										>
											{STR_RESERVED[appContext.language]}
										</h6>
									</div>
								</div>
							}
							
						</div>


					</div>
				}
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}